/**
 * Google Analytics — inicijalizacija gtag.js i page view tracking za React Router SPA.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { GA_TRACKING_ID } from '@/shared/constants';
import { initGoogleAnalytics, trackPageView } from '@/shared/analytics/googleAnalytics';

/** Učitava gtag.js jednom pri mount-u. */
export function GoogleAnalyticsInit() {
  useEffect(() => {
    if (!GA_TRACKING_ID) return;
    initGoogleAnalytics(GA_TRACKING_ID);
  }, []);

  return null;
}

/** Šalje page view pri promeni rute. */
export function GoogleAnalyticsPageViews() {
  const location = useLocation();

  useEffect(() => {
    if (!GA_TRACKING_ID) return;
    trackPageView(GA_TRACKING_ID, `${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
}
